import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const loadProviders = (parameters = {}) => {
  const endpoint = `/providers${getUrlParameters(parameters)}`;

  return apiActionCreator({
    endpoint,
    'authenticated': true,
    'types': [
      ActionTypes.LOAD_PROVIDERS_REQUEST,
      ActionTypes.LOAD_PROVIDERS_SUCCESS,
      [
        ActionTypes.LOAD_PROVIDERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const editProvider = (code, data) => apiActionCreator({
  'endpoint': `/providers/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.SUBMIT_EDIT_PROVIDER_REQUEST,
    [
      ActionTypes.SUBMIT_EDIT_PROVIDER_SUCCESS,
      MessageActions.addMessageBoxInfo('Proveedor actualizado satisfactoriamente'),
    ],
    [
      ActionTypes.SUBMIT_EDIT_PROVIDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});

export const loadProviderOrders = (code) => apiActionCreator({
  'endpoint': `/providers/${code}/orders`,
  'authenticated': true,
  'types': [
    ActionTypes.LOAD_PROVIDER_ORDERS_REQUEST,
    ActionTypes.LOAD_PROVIDER_ORDERS_SUCCESS,
    [
      ActionTypes.LOAD_PROVIDER_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const initializeProviderData = (data) => ({
  'type': ActionTypes.INITIALIZE_PROVIDER_DATA,
  'payload': data,
});

export const filterProviders = (value) => ({
  'type': ActionTypes.FILTER_PROVIDERS,
  'payload': value,
});

export const changeProviderTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDER_TEXT_FILTER,
  'payload': value,
});

export const changeProvidersListPage = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDERS_LIST_PAGE,
  'payload': value,
});

export const changeProvidersListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDERS_LIST_PAGE_SIZE,
  'payload': value,
});

export const changeProviderTransportType = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDER_TRANSPORT_TYPE,
  'payload': value,
});

export const toggleOrderDetail = (value) => ({
  'type': ActionTypes.TOGGLE_ORDER_DETAIL,
  'payload': value,
});
